import { ApiClient } from './api-client';
import { ProspectItem, RelationType, SentEmailNotification } from '../types';

export interface CreateProspectPayload {
  siret: string;
  registration_date: string;
  contact_position: string;
  company_size: string;
  relation_type: RelationType;
  relation_details: string;
}

export interface CreateProspectResponse {
  message: string;
  prospect: ProspectItem;
  is_duplicate: boolean;
  duplicate_message: string | null;
  emails_sent_count: number;
}

export class ProspectApi {
  public static async createProspect(payload: CreateProspectPayload): Promise<CreateProspectResponse> {
    return ApiClient.request<CreateProspectResponse>('/api/prospects', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  public static async getMyProspects(): Promise<ProspectItem[]> {
    return ApiClient.request<ProspectItem[]>('/api/prospects/my');
  }

  public static async getMyNotifications(): Promise<SentEmailNotification[]> {
    return ApiClient.request<SentEmailNotification[]>('/api/notifications/my');
  }
}
